import {
    Chart, Series, CommonSeriesSettings, Legend, ValueAxis, Title, Export, Tooltip, Grid, Format, Margin, Label, SeriesTemplate, Size
} from 'devextreme-react/chart';
import { makeStyles } from '@material-ui/core';
import React , { useEffect, useState } from 'react';
import { locale } from "devextreme/localization";
import { Button } from 'devextreme-react/button';
import { FadingBalls } from 'react-cssfx-loading/lib';


export default function WasteStreamsPerMonth(props) {
    const classes = useStyles();
    const [filter, setFilter] = useState(null);
  
    locale(navigator.language || navigator.browserLanguage)
    useEffect(() => {
        setFilter(props.filter);
    }, [props.filter]);

    const onChartClicked = (e) => {
        var value = e.target.initialValue;
        var data = e.target.data;
        var amount = Object.keys(data).length;
        var keys = Object.keys(data);
        var values = Object.values(data)
        var e = {};
        e.target = {};
        e.target.data = {};

            for (var i = 0; i < amount; i++) {
                if(values[i] === value){
                    e.target.data.material = keys[i];
                    e.target.data.quantity = value;
                    props.onPointClick(e);
                }
            }
      }
    return (
        <div className={classes.wasteStreamContainer}>
            <Button className={classes.buttonContainer}
                    text={"Terug"}
                    icon="chevronleft"
                    visible={filter !== null}
                    onClick={props.onButtonClick}
                />
            <Chart className={classes.chart} dataSource={props.rows} onPointClick={onChartClicked} palette="Ocean" title={filter !==null ? filter +" per maand" : "Afvalfractie per maand"} >
            <Size
                    height={550}
                />
                <Margin top={20} bottom={20} left={30} right={30} />
                <ValueAxis>
                    <Grid visible={true} />
                </ValueAxis>
                <CommonSeriesSettings  argumentField="month" type="stackedBar">
                </CommonSeriesSettings>
                {props.chartWastestreams.map(wastestream => {
                    return (<Series
                        key={wastestream}
                        valueField={wastestream}
                        name={wastestream} >
                        <Format type="fixedPoint" decimalSeparator="," precision={2} />
                   </Series>)
                })}

                <ValueAxis position="right">
                    <Title text={"Tonnage"} />
                </ValueAxis>
                <Legend
                    verticalAlignment="bottom"
                    horizontalAlignment="center"
                    itemTextPosition="top"
                />
                <Export enabled={true} />

                <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
                    <Format location="edge" type="fixedPoint" decimalSeparator="," precision={2} />
                </Tooltip>
               
            </Chart>
            {
                props.isLoading ? 
                    <div className={classes.loadingNewData}>
                        <div className={classes.loadingContainer}>
                            <div className={classes.loadingCharts}>{"Grafiek laden"}</div>
                            <FadingBalls color="#1F8FA5" width="15px" height="15px"></FadingBalls>
                        </div>
                    </div> 
                    : <React.Fragment></React.Fragment>
            }
          
        </div>
    )

}
const tonnageFormatter = new Intl.NumberFormat(
    'nl-BE', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  );
function customizeLabel(args) {
    const valueText = tonnageFormatter.format(args.originalValue);
    return ` <div class="tonnage"> ${valueText} TON</div>`;
  }

  const customizeTooltip =(arg) => {
    const valueText = tonnageFormatter.format(arg.originalValue);
    const percentage = tonnageFormatter.format((arg.percent * 100).toFixed(2));
    return {
      text: `${arg.seriesName} - ${valueText} TON - ${percentage}%`,
    };
  }
const useStyles = makeStyles(() => ({
    wasteStreamContainer: {
        position: 'relative',

        height: '550px',
        background: 'white',
        width: '100%',
    },
    buttonContainer:{
        textAlign: 'center',
        height: '40px',
        position: 'absolute',
        top: '28px',
        left:'5px',
    },
    loadingNewData: {
        height: "100%",
        width: "100%",
        background: "white",
        position: "absolute",
        top: "0",
        opacity: '50%'
    },
    loadingContainer: {
        position: 'relative',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    }
}));